<mat-form-field class="dict-form-field" [appearance]="appearance ? appearance : null" [ngClass]="color ? 'select-color-' + currentColor : ''">
  <mat-label>{{ label }}</mat-label>
  <mat-select *ngIf="!returnKey" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple" >
    <mat-option>
      <ngx-mat-select-search [formControl]="filterControl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of (filteredItems !== null ? filteredItems : items)" [value]="item.id" matTooltip="{{item.note}}">
      {{ item.name }}
    </mat-option>
  </mat-select>
  <mat-select  *ngIf="returnKey" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple" >
    <mat-option >
      <ngx-mat-select-search [formControl]="filterControl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of (filteredItems !== null ? filteredItems : items)" [value]="item.key" matTooltip="{{item.note}}">
      {{ item.name }}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
